<template>
<div>
  <p>
    CWE-{{ vulnerability.number }}
  </p>
  <p>
    {{ vulnerability.description }}
  </p>

  <p>Recommendation</p>
  <p>{{ finding.poc.recommendation }}</p>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  props: {
    vulnerability: {
      type: Object,
      default: () => ({
        poc: {}
      })
    }
  },

  computed: {
    ...mapGetters('finding', [
      'finding'
    ])
  }

}
</script>